$(document).ready(function() {

	$('.cardfiles-close').on('click', function() {
		$('.modal__cardfile').removeClass('open');
	});

	$('.cardfile-add').on('click', function() {
		$.post('/buy-credits/add-card/', {})
		.done(function(response) {
			// Handle the successful response here
			console.log(response);

			$('#payment-form').attr('data-client-secret', response.client_secret);

			initializeCardForm(response);

			$('.modal__cardfile').addClass('open');
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			// Handle errors here
			console.error("Error:", textStatus, errorThrown);
			console.error("Response:", jqXHR.responseText);

			alert("An error occurred: " + (jqXHR.responseJSON?.message || "Please try again later..."));
		});
	});

	if ('.cardfile-add'.length) {
		function completeCredits(creditId) {
			$.post('/buy-credits/add-card-complete/', { class_id: classId }, function(response) {
				$('.modal__cardfile--inner').html(`
					<h3><i class="fal fa-check"></i>Card added on file!</h3>
					<p>The credits have been added to your account.</p>
					<div class="buttons">
						<a href="/" class="button button__black">Continue</a>
					</div>
				`);

				console.log(response);
			});
		}

		function initializeCardForm(paymentDetails) {
			var stripe = Stripe(stripePublishableKey);
			var elements = stripe.elements();
			var $form = $('#payment-form');
			var $errorMessage = $('#error-message');
			var clientSecret = $form.data('client-secret');

			// Custom styling
			var style = {
				base: {
					lineHeight: '44px'
				},
			};

			// Create individual elements with the custom style
			var cardNumberElement = elements.create('cardNumber', { style: style });
			var cardExpiryElement = elements.create('cardExpiry', { style: style });
			var cardCvcElement = elements.create('cardCvc', { style: style });

			// Mount the elements to their respective divs
			cardNumberElement.mount('#card-number-element');
			cardExpiryElement.mount('#card-expiry-element');
			cardCvcElement.mount('#card-cvc-element');

			// Form submission handler
			$form.on('submit', function(e) {
				e.preventDefault();
				$errorMessage.text(''); // Clear previous errors
				var $submitButton = $('#submit');

				// Disable the button and update the text
				$submitButton.prop('disabled', true).html('Please wait...');

				stripe.confirmCardSetup(clientSecret, {
					payment_method: {
						card: cardNumberElement,
						billing_details: {
							name: $('#cardholder-name').val(),
							email: $('#cardholder-email').val(),
						},
					},
				}).then(function(result) {
					if (result.error) {
						// Display error message
						$errorMessage.text(result.error.message);
						// Restore the button
						$submitButton.prop('disabled', false).html('Add Card <i class="fa-light fa-arrow-right ml"></i>');
					} else {
						// Handle successful card setup
						window.location.href = window.location.origin + window.location.pathname + '?card-stored#book';
					}
				});
			});
		}
	}


});